import { InMemoryCache, defaultDataIdFromObject } from "@apollo/client/cache";

const TypePerson = "Person";
const Membership = "Membership";
const IndividualAllocation = "IndividualAllocation";
const Import = "Import";

const merge = (existing = [], incoming) => {
  return incoming;
};

const mergeTagMetadata = (existing, incoming) => {
  if (!incoming) {
    return existing;
  }
  return { ...existing, ...incoming };
};

const cache = new InMemoryCache({
  typePolicies: {
    Tag: {
      fields: {
        tagAttributesMetaData: {
          merge: mergeTagMetadata,
        },
      },
    },
    LinkedStrategy: {
      keyFields: false,
    },
    Group: {
      fields: {
        tags: {
          merge,
        },
      },
    },
    ObjectiveAttribute: {
      keyFields: false,
    },
    GroupAttribute: {
      keyFields: false,
    },
    Person: {
      fields: {
        memberOf: {
          merge,
        },
        memberships: {
          merge,
        },
        allocations: {
          merge,
        },
        tags: {
          merge,
        },
        accessGroups: {
          merge,
        },
      },
    },
  },
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case Import:
        return `${Import}:${object.id}-${object.created}`; // import ids may not be unique
      case TypePerson:
        return `${TypePerson}:${object.aggregateId}`;
      case IndividualAllocation:
        return `${IndividualAllocation}:${object.allocationId}`;
      case Membership:
        return `${Membership}:${object.currentCompositeId}`;
      default:
        return defaultDataIdFromObject(object);
    }
  },
  cacheRedirects: {
    Query: {
      getPerson: (_, args, { getCacheKey }) =>
        getCacheKey({ __typename: TypePerson, aggregateId: args.aggregateId }),
    },
  },
});

export default cache;
